/**
 * digifie 内のモジュールを全てインポートしてまとめてエクスポートする
 * モジュールを使用する場合は import * as digifie from 'このファイルのパス';　して、
 * digifie.各モジュールの名前空間.各モジュール名
 * 例）digifie.events.Event
*/

// digifie 以下に名前空間を持つモジュール群をインポート
import * as events from './events';
import * as utils from './utils';
import * as items from './items';
import * as controls from './controls';
import * as manager from './manager';
import * as view from './view';

// まとめてエクスポート
export {
  events,
  utils,
  items,
  controls,
  manager,
  view,
};
